// @flow

import React, {Component} from 'react';
import I18n from '../../i18n/I18n';

// -- views
import Select from 'react-select';
import _ from "lodash"

export default function LocalizableSelect(props) {

  // Find selected option(s)
  let selectedValue;

  if (props.multi) {
    if (Array.isArray(props.value)) {
      // we iterate over the selected values, that can be either primitives or objects
      selectedValue = props.value.map(val => {
        if (val === null || val === undefined) {
          return null;
        }
        if (typeof val !== "object") {
          // the "value" is a primitive (string or number), we need to find the corresponding option object in the options array
          const option = props.options && props.options.find(
              opt => opt.value === val);
          return option ? option : {value: val, label: val};
        } else {
          // we have the case where the selected values are removed from the options (because we don't want the user to be able to select them twice)
          // so we can't retrieve the selected value from the options.
          // In this case, we just return the value as is, and let react-select handle it
          // (it can handle values that are not in the options)
          return val;
        }
      })
      // don't keep undefined values
      .filter(Boolean);
    } else {
      selectedValue = []
    }
  } else {
    // not "multi", we expect a single value, that can be either a string/number or an object
    if (props.options && typeof props.value !== "object") {
      // the "value" is a string, we need to find the corresponding option object in the options array
      selectedValue = props.options.find(opt => opt.value === props.value)
    } else {
      // the "value" is already an object, we can use it directly
      selectedValue = props.value
    }
  }

  const isClearable = props.clearable !== undefined
      ? props.clearable           // explicitly set
      : true;                     // old behaviour (1.0.0‑rc.3)



  return (<Select
          classNamePrefix="react-select"
          searchPromptText={I18n.tr('components.select.search_prompt_text')}
          searchingText={I18n.tr('components.select.searching_text')}
          noResultsText={I18n.tr('components.select.no_results_text')}
          clearAllText={I18n.tr('components.select.clear_all_text')}
          clearValueText={I18n.tr('components.select.clear_value_text')}
          // the `{label}` is taken as parameter by our i18n, but should not. Tricks: we set a parameter and set `{label}` again.
          addLabelText={I18n.tr('components.select.add_label_text',
              {label: '{label}'})}
          placeholder={I18n.tr('components.select.placeholder')}
          disabled={props.readOnly || props.disabled}
          {...props}
          value={selectedValue} // object or array, depending of "multi"
          isMulti={props.multi}
          isClearable={isClearable}
      />
  );
}
